import {IFormFilesInterface} from "../Shared/form-files.interface";
export type IAddressChangeFormFourthSection = {
    SupportingDocuments?: Array<IFormFilesInterface>,
}

export const AddressChangeFormFourthSectionInitialState = (): IAddressChangeFormFourthSection => ({
    SupportingDocuments: undefined
})